import { Controller } from '@hotwired/stimulus'

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || ''
let timer = ''
export default class AudienceController extends Controller {
  static targets = ['submitInterestButton', 'inputField']

  connect() {
    this.html = document.getElementById('content-frame').innerHTML
    const location = {
      lat: $('#audience_lat').val() || '',
      lng: $('#audience_lng').val() || '',
      city: $('#audience_city').val() || '',
      state: $('#audience_state').val() || '',
      country: $('#audience_country').val() || '',
      place: $('#audience_place').val() || ''
    }

    const interestIds = {}
    $('#interests-container p').each(function () {
      const id = $(this).data('id')
      interestIds[id] = $(this).text()
    })
    this.formData = {
      location: {
        1: location
      },
      interest_ids: interestIds,
      location_type: $('#audience_location_type').val() || 'Regional'
    }
    this.interests = interestIds
  }

  updateSubmit(e) {
    if ($('.all-user-chk:checked').length === 0) {
      $('.audience-btn').addClass('disabled')
    } else {
      $('.audience-btn').removeClass('disabled')
    }
  }

  async selectuser(e) {
    e.preventDefault()
    let id = $(e.target).closest('form').attr('id')
    if (id == '') {
      $('.error-msg').html('Before select location, interest & age')
    } else {
      $('.user-error').html('')

      const turboRequest = await this.loadTurboRequest()

      await turboRequest('/audiences/all_user_list', {
        method: 'POST',
        params: {
          id: id
        }
      })
    }
  }

  toggleDisabledState(event) {
    event.preventDefault()
    const audienceChecked = $('.audience_name:checked').length > 0
    const automaticChecked = $('.is_automatic:checked')[0] != undefined
    if (audienceChecked) {
      $('.select-automatic').prop('checked', false)
    }
    $('.select-automatic').prop('disabled', audienceChecked)
    $('.select-automatic').toggleClass('disabled', audienceChecked)
    $('.select-audience').toggleClass('disabled', automaticChecked)
    $('.create-audience').toggleClass(
      'disabled',
      !(audienceChecked || automaticChecked)
    )
  }

  editpost(e) {
    e.preventDefault()
    const target = $(e.target)
    const audienceId = target.attr('data-id')
    if ($(e.target).attr('data-pause') == 'true') {
      $('.edit-promote').removeClass('d-none')
      if ($(e.target).attr('data-automatic') == 'true') {
        $('.edit-promote')[0].setAttribute(
          'href',
          '/audiences/' +
          $(e.target).attr('data-post') +
          '/promote_post?audience=' +
          $(e.target).attr('data-id')
        )
      } else {
        $('.edit-promote')[0].setAttribute(
          'href',
          '/audiences/' +
          $(e.target).attr('data-id') +
          '/edit?add_new_audience=true'
        )
      }
    } else {
      $('.edit-promote').addClass('d-none')
    }
    if (audienceId) {
      $('.delete-promote').removeClass('disabled')
      $('.delete-promote').attr('href', '/audiences/' + audienceId + '')
    } else {
      $('.delete-promote').addClass('disabled')
    }
  }

  showLocation(e) {
    e.preventDefault()
    $('.audience-location-block').removeClass('d-none')
    $('.form-audience').addClass('d-none')
  }

  showInterest(e) {
    e.preventDefault()
    this.sortInterests()
    $('.audience-interest-block').removeClass('d-none')
    $('.form-audience').addClass('d-none')
    this.originalInterests = { ...this.interests }
    if (event.currentTarget.nextElementSibling.innerHTML === '') {
      this.clearInterests()
    } else {
      this.submitInterestButtonTarget.classList.remove('disabled')
    }
  }

  showAge(e) {
    e.preventDefault()
    $('.audience-age-block').removeClass('d-none')
    $('.form-audience').addClass('d-none')
  }

  setlocationFormData(location) {
    this.formData['location'] = { 1: location }
    $('.regional-locations').html(`
      <div class="position-relative" id="location-1">
        <div class="text-center text-black-paint text-white d-block fs-md-20 fs-16 p-font-bold px-4 input-btn-bg bg-center bg-100 bg-no-repeat py-3 max-w-480px">
          <div class="d-flex align-items-center justify-content-center px-lg-4 px-2 py-3">
            <span class="text-white me-2">${location.place}</span>
            <a class="text-danger cursor-pointer" data-action="audience#removeLocation" data-key="1">x</a>
          </div>
        </div>
      </div>
    `)
  }

  setLocalLocationFormData(location) {
    this.formData['local_location'] = location
  }

  removeLocation(e) {
    e.preventDefault()
    let key = e.currentTarget.dataset?.key
    $('#location-' + key).remove()
    delete this.formData['location'][key]
  }

  selectLocationType(e) {
    this.formData['location_type'] = e.currentTarget.dataset?.type
  }

  selectInterest(e) {
    const target = e.currentTarget
    if (target.checked) {
      this.interests[target.value] = target.dataset?.text
      this.submitInterestButtonTarget.classList.remove('disabled')
    } else {
      delete this.interests[target.value]
      if (Object.keys(this.interests).length === 0) {
        this.submitInterestButtonTarget.classList.add('disabled')
      }
    }
  }

  submitLocation(e) {
    const place =
      this.formData['location_type'] === 'Local'
        ? this.formData['local_location']?.place
        : Object.values(this.formData['location'])[0]?.place || ''
    const audienceLocationSelect = document.querySelector(
      '.audience-location-select'
    )

    audienceLocationSelect.innerHTML = ''
    $('.location-value').html('')

    if (place && this.inputFieldTarget.value !== '') {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = this.html
      const span = tempDiv.querySelector('span.frame-text')
      const removeButton = tempDiv.querySelector('.remove-interest')
      removeButton.dataset.key = '555'
      if (span) {
        span.textContent = place
      }
      audienceLocationSelect.innerHTML = tempDiv.innerHTML
    } else {
      document.getElementById('aud-location-error').innerHTML =
        "Location can't be blank"
      return
    }
    document.getElementById('aud-location-error').innerHTML = ''
    $('.audience-location-block').addClass('d-none')
    $('.form-audience').removeClass('d-none')
    this.checkNode()
  }

  backLocation() {
    $('.audience-location-block').addClass('d-none')
    $('.form-audience').removeClass('d-none')
    $('#content_error p').html('')
    this.checkNode()
  }

  submitInterest() {
    const audienceSelect = document.querySelector('.audience-interest-select')
    this.formData.interest_ids = { ...this.interests }
    audienceSelect.innerHTML = ''
    const htmlContent = this.html
    for (const [id, place] of Object.entries(this.formData.interest_ids)) {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlContent

      const span = tempDiv.querySelector('span.frame-text')
      span.textContent = place

      const removeButton = tempDiv.querySelector('.remove-interest')
      removeButton.dataset.key = id

      audienceSelect.innerHTML += tempDiv.innerHTML
    }
    $('.audience-interest-block').addClass('d-none')
    $('.form-audience').removeClass('d-none')
    $('#interests-container p').remove()
    $('#content_error').html('') // remove error when submit the interest form

    this.checkNode()
  }

  removeInterest(e) {
    e.preventDefault()
    const key = e.currentTarget.dataset.key
    if (!key) return
    if (key === '555') {
      $('.audience-location-select').html('')
      $('.regional-locations').html('')
      delete this.formData['location'][1]
      return
    }
    delete this.interests[key]
    delete this.formData.interest_ids[key]
    e.currentTarget.closest('.selected-interest')?.remove()
    $(`[name="audience[interest_ids][]"][value="${key}"]`).prop('checked', false)
    if (Object.keys(this.interests).length === 0) {
      this.submitInterestButtonTarget.classList.add('disabled')
    }
    this.checkNode()
  }

  backInterest(e) {
    this.interests = { ...this.formData.interest_ids }

    const selectedIds = Object.values(this.formData.interest_ids)
    console.log(selectedIds)

    $('.audience-interest-block').addClass('d-none')
    $('.form-audience').removeClass('d-none')
    this.checkNode()

    $('[name="audience[interest_ids][]"]').each(function () {
      const value = this.dataset.text
      if (selectedIds.includes(value)) {
        this.checked = true
      } else {
        this.checked = false
      }
    })
  }

  submitAge() {
    let age = $('.age-value').val().split(';')
    const checkboxes = document.querySelectorAll(
      'input[name="audience[gender][]"][type="checkbox"]:checked'
    )
    const selectedValues = Array.from(checkboxes).map(
      (checkbox) => checkbox.value
    )

    $('.audience-age-select').html(
      '<span class="bg-clip-text text-transparent text-gradient-orange fs-24">' +
      selectedValues.join(', ') +
      '</span> <span class="bg-clip-text text-transparent text-gradient-orange fs-24"> | ' +
      age[0] +
      '-' +
      age[1] +
      ' Years</span>'
    )
    $('.audience-age-block').addClass('d-none')
    $('.form-audience').removeClass('d-none')
    $('#content_error').html('') // remove error when submit the gender form
    this.checkNode()
  }

  backAge() {
    $('.audience-age-block').addClass('d-none')
    $('.form-audience').removeClass('d-none')
    $('#content_error').html('')
    this.checkNode()
  }

  checkNode() {
    const parentInterest = document
      .querySelectorAll('.audience-interest-select')[0]
      .hasChildNodes()
    const parentAge = document
      .querySelectorAll('.audience-age-select')[0]
      .hasChildNodes()
    const parentLocation = document
      .querySelectorAll('.audience-location-select')[0]
      .hasChildNodes()
    if (parentInterest && parentAge && parentLocation) {
      $('.audience-btn').removeClass('disabled')
    } else {
      $('.audience-btn').addClass('disabled')
    }
  }

  async searchInterests(event) {
    if (!this.searchInterestsDebounced) {
      const debounce = (await import("../helpers/timing_helpers")).debounce
      this.searchInterestsDebounced = debounce(
        (value) => this.performInterestSearch(value),
        500
      )
    }
    this.searchInterestsDebounced(event.target.value)
  }

  async performInterestSearch(value) {
    const turboRequest = await this.loadTurboRequest()

    await turboRequest("/audiences/search_interests", {
      method: "POST",
      params: {
        searches_interest_search: {
          name: value
        }
      }
    })
  }

  async submitForm(e) {
    e.preventDefault()
    if ($(this.element).valid() === false) {
      return
    }
    const formData = new FormData(this.element)
    const prefix = this.element.dataset.googleMapFormPrefix || 'audience'
    if (!prefix) return

    // pass locationData correctly
    const locationData =
      this.formData['location_type'] === 'Local'
        ? this.formData['local_location'] || {}
        : Object.values(this.formData['location'] || {})[0] || {}

    for (const key of ['lat', 'lng', 'city', 'state', 'country', 'place']) {
      formData.append(`${prefix}[${key}]`, locationData[key] || '')
    }

    if (this.formData['location_type'] === 'Local') {
      formData.append(`${prefix}[location_type]`, 'Local')
    }

    const turboRequest = await this.loadTurboRequest()

    await turboRequest(this.element.getAttribute('action'), {
      method: this.element.dataset.method,
      params: formData,
      turboStream: true
    })
  }

  removeError() {
    $('#content_error p').text('')
  }

  sortInterests() {
    const interestIds = Object.keys(this.interests)
    const container = document.querySelector('.audience-interests')

    if (!container) return

    const items = [...container.querySelectorAll('.form-check')]

    items.sort((a, b) => {
      const aId = a.querySelector('input[type="checkbox"]').value
      const bId = b.querySelector('input[type="checkbox"]').value

      return interestIds.includes(aId) - interestIds.includes(bId)
    })

    items.forEach(item => container.appendChild(item))
  }

  clearInterests() {
    document
      .querySelectorAll('.audience-interests input[type="checkbox"]:checked')
      .forEach((checkbox) => {
        checkbox.checked = false
      })

    this.interests = {}
    this.formData.interest_ids = {}
    this.submitInterestButtonTarget.classList.add('disabled')
  }

  async loadTurboRequest() {
    const turboRequest = (await import("../helpers/api")).turboRequest
    return turboRequest
  }
}
